import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function FavouritePaymentCard({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>FavouritePaymentCard</title>
      <path
        d="M21 11.5V8C21 6.89543 20.1046 6 19 6H5C3.89543 6 3 6.89543 3 8V17C3 18.1046 3.89543 19 5 19H13"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 10H20.5"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5147 14.5147C14.8284 15.201 14.8284 16.3137 15.5147 17L18 19.4853L20.4853 17.0001C21.1716 16.3138 21.1716 15.2011 20.4853 14.5148C19.799 13.8285 18.6863 13.8285 18 14.5147C17.3138 13.8285 16.201 13.8284 15.5147 14.5147Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 15H9"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
